import React from "react";
import { FaTaxi } from "react-icons/fa";

const RideSharePlaceholder = ({ title }) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center">
      <FaTaxi size={48} color="#f0b342" className="mb-3" />
      <h5 className="fw-bold mb-2">{title}</h5>
      <p className="text-muted">Coming soon — backend integration in progress.</p>
    </div>
  );
};

export default RideSharePlaceholder;
